import { jsx } from 'react/jsx-runtime';
import { useResponsive } from '../hooks/useResponsive.js';

const ResponsiveIcon = ({ mobile: Mobile, default: Default }) => {
  const { isMobileView } = useResponsive();
  return isMobileView ? /* @__PURE__ */ jsx(Mobile, {}) : /* @__PURE__ */ jsx(Default, {});
};

export { ResponsiveIcon };
//# sourceMappingURL=ResponsiveIcon.js.map
